export default __webpack_public_path__ + "static/homeLandscapeMeat-7f01bed5aa0b6ae395b6ab9cee0b7fa5.jpg";